
// ============================================================================
// CUSTOM JS - Dexter
// ============================================================================

// Close Newsletter PopUp Subscription
// This need js.cookies.js
// Click event listener for close button
document.querySelector('.newsletter-popup-inner > .close').addEventListener('click', function() {
  // Hide newsletter popup
  document.querySelector('.newsletter-popup').style.display = 'none';
  // Set cookie to remember user action for 7 days

  // Check if the popup has been closed once
  if (Cookies.get('jasignupclose')) {
    // Set a second cookie to allow showing the popup one more time
    Cookies.set('popupShownTwice', true, { expires: 30 });
  } else {
    Cookies.set('jasignupclose', true, { expires: 30 });
  }
});

// Check if cookies exist
var JenniferCookieClose = Cookies.get('jasignupclose');
var popupShownTwice = Cookies.get('popupShownTwice');

// Get reference to newsletter popup element
var popupdiv = document.querySelector('.newsletter-popup');

console.log(JenniferCookieClose);
console.log(popupShownTwice);

// Check cookie values
if (JenniferCookieClose && popupShownTwice) {
  // Hide newsletter popup if both cookies exist
  popupdiv.style.display = 'none';
} else {
  // Show newsletter popup if one or both cookies don't exist
  popupdiv.style.display = 'block';
}
